import { Box, Typography, useTheme } from "@mui/material";

const ACCENTS = {
    blue: { main: "#0D358C", soft: "#0D358C14", border: "#0D358C22" },
    sky: { main: "#2563EA", soft: "#2563EA14", border: "#2563EA22" },
    teal: { main: "#457b9d", soft: "#457b9d18", border: "#457b9d28" },
    indigo: { main: "#1a5bb8", soft: "#1a5bb814", border: "#1a5bb822" },
};

/** Stat cards — text + icon side by side (no overlap in RTL). */
export default function DashboardStatCard({
    label,
    value,
    icon,
    className = "w-full min-w-[160px] flex-1 mx-2 max-sm:mx-auto max-sm:mt-2",
    onClick,
    footer,
    accent = "blue",
}) {
    const theme = useTheme();
    const palette = ACCENTS[accent] || ACCENTS.blue;

    return (
        <Box
            onClick={onClick}
            sx={{
                cursor: onClick ? "pointer" : "default",
                border: "1px solid",
                borderColor: palette.border,
                background: theme.palette.mode === "dark"
                    ? theme.palette.background.paper
                    : `linear-gradient(145deg, ${palette.soft} 0%, #ffffff 62%)`,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                minHeight: 128,
                p: 2,
            }}
            className={`rounded-2xl shadow-md max-sm:w-full home-card-hover ${className}`}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 1.5,
                    width: "100%",
                }}
            >
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                        variant="body2"
                        sx={{ color: "text.secondary", fontWeight: 600, lineHeight: 1.4 }}
                        noWrap
                    >
                        {label}
                    </Typography>
                    <Typography
                        variant="h4"
                        sx={{ pt: 0.75, fontWeight: 800, color: palette.main, lineHeight: 1.2 }}
                        noWrap
                    >
                        {value}
                    </Typography>
                </Box>

                <Box
                    sx={{
                        width: 44,
                        height: 44,
                        flexShrink: 0,
                        borderRadius: "14px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: palette.main,
                        color: "#fff",
                        boxShadow: `0 8px 20px ${palette.main}40`,
                        "& svg": { fontSize: 22 },
                    }}
                >
                    {icon}
                </Box>
            </Box>

            {footer ? <Box sx={{ mt: 1 }}>{footer}</Box> : null}
        </Box>
    );
}
